import TextButtonM from "@common/components/button/TextButtonM"
import { theme } from "@common/theme/theme"
import React from "react"
import { useNavigation } from "@react-navigation/native"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { connect } from "react-redux"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { skillSetsService } from "@data/services/skillSetsService"
import { IS_WEB } from "@common/utils/mobileUtils"
import * as WebBrowser from "expo-web-browser"

function StripeExpressDashboardButton(props) {

    const { style } = props

    const stripeConnectDetailsSubmitted = props.user?.stripe_connect_details_submitted

    useApiStatus(
        skillSetsService.getDashboardExpressUrl, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (data) => {
            if (IS_WEB) {
                window.open(data?.url, "_blank")
            } else {
                WebBrowser.openBrowserAsync(data?.url)
            }
        }, // success callback
    )


    const navigation = useNavigation()

    return <>
        {stripeConnectDetailsSubmitted && <>
            <TextButtonM onPress={() => {
                props.apiRequest(skillSetsService.getDashboardExpressUrl)
            }}
                         style={{
                             paddingHorizontal: 4,
                             marginTop: 10,
                             ...style,
                         }}
                         trackingId={"stripe-dashboard-express"}
                         fontWeight={"Bold"}
                         disabled={props.getDashboardExpressUrlRequest}
                         color={props.getDashboardExpressUrlRequest ? theme.colors.link : theme.colors.primary}
                         label={props.getDashboardExpressUrlRequest ? "Redirection..." : "SUIVRE MES PAIEMENTS"} />
            <TextButtonM onPress={() => {
                navigation.push("tutor-lives-history")
            }}
                         style={{
                             paddingHorizontal: 4,
                             marginTop: 10,
                             textTransform: "uppercase",
                             ...style,
                         }}
                         fontWeight={"Bold"}
                         color={theme.colors.primary}
                         label={"Historique des lives"} />
        </>
        }
    </>
}

const mapStateToProps = state => {
    return {
        user: state.data.currentUser?.object,
        getDashboardExpressUrlRequest: state.api.getDashboardExpressUrl?.request,

    }
}

const mapDispatchToProps =
    {
        apiRequest,
        apiIdle,
    }

export default connect(mapStateToProps, mapDispatchToProps)(StripeExpressDashboardButton)